import type { Outcome } from '@/lib/apollo/model/outcome'
import { OverallOutcomeStatus } from '@/lib/apollo/model/outcome'
import type { Application } from '@/types/Activity'

export const subjectIsInFinalState = (outcome?: Outcome) => {
  if (!outcome) return false

  return [
    OverallOutcomeStatus.accepted,
    OverallOutcomeStatus.rejected,
    OverallOutcomeStatus.pass,
  ].includes(outcome.status)
}

export const getTypeLabel = (type: string): string =>
  type === 'applicant' ? 'tenant' : type

export const isTenant = (type?: string): boolean =>
  type === 'applicant' || type === 'tenant'

export const isGuarantor = (type?: string): boolean => type === 'guarantor'

export const isEmployer = (type?: string): boolean => type === 'employer'

export const isLandlord = (type?: string): boolean => type === 'landlord'

export const isAccountant = (type?: string): boolean => type === 'accountant'

export const isRefCompleted = (application: Application) =>
  application.milestones.find(milestone => milestone.event === 'subject.complete') !==
  undefined

export const isCorporate = (journeyType?: string): boolean => journeyType === 'corporate'

export const isCorporateTenant = (subjectType?: string, journeyType?: string): boolean =>
  isTenant(subjectType) && isCorporate(journeyType)
